module.exports = __webpack_public_path__ + "img/device_am35_d_a.61007e96.png";